import { render, staticRenderFns } from "./ButtonScrollToTop.vue?vue&type=template&id=5baef2ac&scoped=true&"
import script from "./ButtonScrollToTop.vue?vue&type=script&lang=js&"
export * from "./ButtonScrollToTop.vue?vue&type=script&lang=js&"
import style0 from "./ButtonScrollToTop.vue?vue&type=style&index=0&id=5baef2ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5baef2ac",
  null
  
)

export default component.exports